import React, { useCallback, useEffect, useState } from 'react';
import { LoadingTruck } from '@goodfynd/react-web.lib.ui';

import CmsApi from '../../../services/api/cms-api';
import { renderCmsBodyComponent } from '../../../utils/cms-util';

import type { CmsPageContentProps } from './types';

export default function CmsPageContent({
  containerCSS,
  render,
  slug,
}: CmsPageContentProps): JSX.Element {
  const [body, setBody] = useState([]);
  const [busy, toggleBusy] = useState(true);

  useEffect(() => {
    if (slug) {
      (async () => {
        try {
          toggleBusy(true);
          const api = new CmsApi();
          const data = await api.getPageData(slug);
          const { body } = data?.fields || {};
          setBody(body);
        } finally {
          toggleBusy(false);
        }
      })();
    }
  }, [slug]);

  const renderBody = useCallback(
    () => (
      <>
        {body?.map(({ fields, type }, index) =>
          (render || renderCmsBodyComponent)(index, type, fields, {
            containerCSS,
          })
        )}
      </>
    ),
    [body, containerCSS, render]
  );

  return busy ? <LoadingTruck /> : renderBody();
}
